import { css, Theme } from '@emotion/react'
import { Box, Typography } from '@mui/material'

type Props = {
  example: {
    needs: string
    solution: string
  }[]
}

const Example: React.FC<Props> = ({ example }) => {
  return (
    <Box css={styles.wrapper}>
      <Box css={styles.container} component='section'>
        <Box css={styles.head}>
          <Typography variant='h1' css={styles.title} color='primary'>
            例えば、こんな支援をさせていただきます
          </Typography>
        </Box>
        <Box component='ul' css={styles.rowsContainer}>
          {example.map((item, idx) => (
            <Box component='li' css={styles.row} key={idx}>
              <div css={styles.needs}>
                <Typography color='primary'>{`「${item.needs}」`}</Typography>
              </div>
              <div css={styles.arrow}>
                <span></span>
              </div>
              <div css={styles.solution}>
                <p>{item.solution}</p>
              </div>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  wrapper: css`
    width: 100vw;
  `,
  container: css`
    max-width: 1180px;
    margin: 0 auto;
  `,
  head: css`
    padding: 40px 60px;
    @media (max-width: 768px) {
      padding: 40px 20px;
    }
  `,
  title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    margin: 4rem 2rem 6rem;
    padding-left: 40px;
    border-left: 8px solid #0d9bbe;
    @media (max-width: 960px) {
      font-size: 2.1rem;
    }
    @media (max-width: 768px) {
      padding-left: 20px;
      margin: 0rem 0rem 2rem;
      font-size: 1.6rem;
    }
  `,
  rowsContainer: css`
    padding-inline-start: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-bottom: 100px;
  `,
  row: (theme: Theme) => css`
    display: flex;
    align-items: center;
    padding: 40px 10px;
    margin: 0 40px 60px;
    border-bottom: 4px dotted ${theme.palette.primary.main};
    @media (max-width: 768px) {
      flex-flow: column;
      padding: 10px;
    }
  `,
  needs: css`
    position: relative;
    width: 40%;
    padding: 0 20px;
    & p {
      font-weight: 700;
      font-size: 1.8rem;
    }
    &:after {
      position: absolute;
      content: '';
      background-image: url('/comment.svg');
      width: 300px;
      height: 90px;
      left: 5px;
      top: -90px;
    }
    &:before {
      z-index: 3;
      position: absolute;
      content: 'お客様のご要望';
      left: 40px;
      top: -80px;
      font-family: 'Noto sans JP', sans-serif;
      font-weight: 500;
      font-size: 2rem;
      color: black;
    }
    @media (max-width: 768px) {
      width: 100%;
      font-size: 1.5rem;
      padding: 0;
      &:after {
        width: 150px;
        height: 45px;
        left: 5px;
        top: -50px;
      }
      &:before {
        left: 20px;
        top: -45px;
        font-size: 1rem;
      }
    }
  `,
  arrow: (theme: Theme) => css`
    display: flex;
    justify-content: center;
    width: 10%;
    & span:after {
      content: '\\f101';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      font-size: 5rem;
      color: ${theme.palette.primary.main};
    }
    @media (max-width: 768px) {
      width: 100%;
      & span:after {
        content: '\\f103';
        font-size: 4rem;
      }
    }
  `,
  solution: (theme: Theme) => css`
    position: relative;
    width: 50%;
    padding: 0 20px;
    & p {
      font-family: 'Noto sans JP', sans-serif;
      font-weight: 700;
      font-size: 1.8rem;
      color: ${theme.palette.primary.main};
    }
    &:after {
      position: absolute;
      content: '';
      background: url('/frame1.svg') no-repeat 50%;
      width: 300px;
      height: 100px;
      left: 20%;
      top: -70px;
    }
    &:before {
      z-index: 3;
      position: absolute;
      content: 'eduadのSolution';
      left: 30%;
      top: -30px;
      font-family: 'Noto sans JP', sans-serif;
      font-weight: 700;
      font-size: 1.3rem;
      color: ${theme.palette.primary.main};
    }
    @media (max-width: 768px) {
      width: 100%;
      font-size: 1.5rem;
      padding: 50px 0 20px;
      &:after {
        width: 210px;
        height: 70px;
        left: auto;
        right: 10px;
        top: -10px;
      }
      &:before {
        left: auto;
        right: 15%;
        top: 15px;
        font-size: 1rem;
      }
    }
  `,
}

export default Example
